import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiGateway } from '../../../api-gateway';
import { Auxiliary } from '../../../models/backend-definitions.module';
import { PageOptions } from '../../../util/backend-util-module';

@Injectable()
export class AuxiliaryListProvider implements Resolve<any> {
    auxiliary: Auxiliary[];
    auxiliaryEdit: Auxiliary;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        if (this.state?.currentPage && state.url.includes(this.state?.path)) {
            this.currentPage = this.state?.currentPage;
        }
        this.auxiliaryEdit = this.state?.currentAuxiliary;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'name';
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([
                this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    get(id: number): Observable<Auxiliary> {
        if (!id) {
            return null;
        }
        return this.gw.get('auxiliary/:id', { id: id });
    }

    get currentAuxiliary(): Auxiliary {
        return this.auxiliaryEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('auxiliary/').subscribe((res: HttpResponse<any>) => {
                this.auxiliary = res.body;
                this.onDataChanged.next(this.auxiliary);
                resolve(res);
            }, reject);
        });

    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('auxiliary/search', pageOptions).subscribe((res: HttpResponse<any>) => {
                if (!CwUtils.compare(this.auxiliary, res.body.content) && res.body.content.length > 0) {
                    this.auxiliary = res.body.content;
                    this.onDataChanged.next(this.auxiliary);
                } else {
                    this.auxiliary = res.body.content;
                }
                resolve(res);
            }, reject);
        });
    }

    getAuxiliaryType(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('auxiliary/auxiliaryType/simpleList')
                .subscribe((res: HttpResponse<any>) => {
                    resolve(res);
                }, reject);
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}

